<template>
  <public-layout>
    <section class="hero lvl3">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Fun Learning Approach
              </p>
              <p class="product-subtitle">
                Putting FUN back into learning!
              </p>
              <p class="product-description">
                Fun Learning is a holistic approach to early education created by Fun Academy.
                 It helps teachers to promote key life skills to children, and nurtures the passion for learning through play and exploration.
                 We developed the Fun Learning approach based on Finnish pedagogical expertise in combination with the best practices around the world.              </p>
              <p class="product-cta">
                <router-link class="button button-large button-secondary" :to="{ name: 'about-us' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/approach.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr>

    <section class="section course-info is-left-aligned">
      <div class="container">
        <div class="columns is-vcentered has-text-centered">
          <div class="column">
            <h2 class="section-title">“The world is filled with enthusiastic, energetic people. Too bad they’re usually under the age of seven.” - Esa Saarinen, Finnish Philosopher</h2>
          </div>
        </div>
        <div class="columns">
          <div class="column is-7">
            <figure class="image">
              <img src="/static/img/assets/learning-is-fun.jpg" alt="">
            </figure>
          </div>
          <div class="column is-5">
            <div class="content">
              <p>Learning is how we become the best version of ourselves. It should be an exhilarating, motivating and transformative experience.</p>
              <p>The Fun Learning Approach:</p>
              <ul>
                <li>Fuels curiosity, fosters creativity and triggers a passion for learning from the very start.</li>
                <li>Encourages every child and teacher to become lifelong learners.</li>
                <li>Enables teachers to bring scientific thinking, nutrition, physical. activity, mindfulness and meaningful use of technology, into the classroom.</li>
                <li>Makes the preschool experience FUN and engaging with collaborative learning through play and exploration.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FLApproachPage.vue